import classNames from 'classnames'
import * as React from 'react'
import { connect } from 'react-redux'
import { useMeasure } from 'react-use'

import { DraftActions } from '../../../../actions/actionTypes'
import { Frame } from '../../../common/Frame'
import LoadingLinear from '../../../common/LoadingLinear/LoadingLinear'
import './DynamicPreview.scss'

const DynamicPreview: React.FC = ({ isLoading, preview }) => {
  const [contentDimensions, setContentDimensions] = React.useState({ height: 0, width: 0 })
  const [ref, { height, width }] = useMeasure()
  const margin = 30
  const parentWidth = width - margin
  const parentHeight = height - margin
  const contentWidth = contentDimensions.width
  const contentHeight = contentDimensions.width * Math.sqrt(2) // for A1,A2..A4,.. papers, height = width * √2
  let scale = Math.min((parentWidth - margin) / contentWidth, (parentHeight - margin) / contentHeight)
  scale = scale > 1 ? 1 : scale
  const contentWidthScaled = contentDimensions.width * scale
  const translateX =
    scale >= 1
      ? ((parentWidth - contentWidthScaled) * 50) / contentWidthScaled
      : ((contentWidth - width) * -50) / contentWidth
  const contentHeightScaled = contentDimensions.width * Math.sqrt(2) * scale
  const translateY =
    scale >= 1
      ? ((height - contentHeightScaled) * 50) / contentHeightScaled
      : ((contentHeight - height) * -50) / contentHeight
  return (
    <div className="DynamicPreview" ref={ref}>
      {<LoadingLinear className={classNames({ hidden: !isLoading })} />}
      <Frame
        style={{
          transform: `translate(${translateX}%, ${translateY}%) scale(${scale})`,
          height: `${contentHeight}px`,
        }}
        onLoad={(dimensions) => setContentDimensions(dimensions)}
      >
        {preview}
      </Frame>
    </div>
  )
}

export default connect(
  (state) => ({
    preview: state.documentPreview,
    isLoading: state.ongoing[DraftActions.PREVIEW_DOCUMENT],
  }),
  () => ({}),
)(DynamicPreview)
